import actions from './constants';

export const hideSaveVocabulary = () => ({
  type: actions.HIDE_SAVE_VOCABULARY,
});

export const updateVocabularyProperties = (code, category, properties) => ({
  type: actions.UPDATE_VOCABULARY_PROPERTIES,
  code,
  category,
  properties,
});

export const updateActiveVocabularyProperties = (properties) => ({
  type: actions.UPDATE_ACTIVE_VOCABULARY_PROPERTIES,
  properties,
});

export const fetchVocabularies = (category, page, pageSize, append) => ({
  type: actions.FETCH_VOCABULARIES,
  category,
  page,
  pageSize,
  append,
});

export const refreshVocabularies = (category, page) => ({
  type: actions.REFRESH_VOCABULARIES,
  category,
  page,
});

export const updateVocabulariesFilter = (category, value) => ({
  type: actions.UPDATE_VOCABULARIES_FILTER,
  category,
  value,
});

export const showVocabularies = (category, append, pageSize, results, resultsCount, totalPages, currentPage) => ({
  type: actions.SHOW_VOCABULARIES,
  category,
  append,
  pageSize,
  results,
  resultsCount,
  totalPages,
  currentPage,
});

export const applyVocabularies = (results) => ({
  type: actions.APPLY_VOCABULARIES,
  category: 'all',
  results,
});

export const showVocabulariesError = (category, error) => ({
  type: actions.SHOW_VOCABULARIES_ERROR,
  category,
  error,
});

export const closeVocabularies = (category) => ({
  type: actions.CLOSE_VOCABULARIES,
  category,
});

export const updateVocabulary = () => ({
  type: actions.UPDATE_VOCABULARY,
});

export const editVocabulary = (code, result) => ({
  type: actions.EDIT_VOCABULARY, code, result,
});

export const resetVocabularySuccess = (code, category, result) => ({
  type: actions.RESET_VOCABULARY_SUCCESS, code, category, result,
});

export const editVocabularyError = (error) => ({
  type: actions.EDIT_VOCABULARY_ERROR,
  error,
});

export const resetVocabularyError = (code, category, name, error) => ({
  type: actions.RESET_VOCABULARY_ERROR, code, category, name, error,
});

export const addVocabularyLink = () => ({
  type: actions.ADD_VOCABULARY_LINK,
});

export const deleteVocabularyLink = (linkUUID) => ({
  type: actions.DELETE_VOCABULARY_LINK,
  linkUUID,
});

export const updateVocabularyLinkProperties = (linkUUID, properties) => ({
  type: actions.UPDATE_VOCABULARY_LINK_PROPERTIES,
  linkUUID,
  properties,
});

export const addVocabularyRoleAction = () => ({
  type: actions.ADD_VOCABULARY_ROLE_ACTION,
});

export const deleteVocabularyRoleAction = (uuid) => ({
  type: actions.DELETE_VOCABULARY_ROLE_ACTION,
  uuid,
});

export const updateVocabularyRoleActionProperties = (uuid, properties) => ({
  type: actions.UPDATE_VOCABULARY_ROLE_ACTION_PROPERTIES,
  uuid,
  properties,
});

export const updateVocabularyEmailProperties = (properties) => ({
  type: actions.UPDATE_VOCABULARY_EMAIL_PROPERTIES,
  properties,
});

export const resetVocabulary = (code, category) => ({
  type: actions.RESET_VOCABULARY,
  code,
  category,
});

export const toggleVocabulariesPresentation = (category, display) => ({
  type: actions.TOGGLE_VOCABULARIES_PRESENTATION,
  category,
  display,
});
